import { filterOptions } from 'utils/methods/helpers';
import { TASK_FIELDS } from 'utils/formFields/task';
import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options.jsx';
import { getServiceTaskCategories } from 'utils/helper/product';

const taskCategories = availableServices => {
  return availableServices;
};

export const taskCategoryFilter = availableServices => {
  return {
    label: 'taskCategories',
    field: 'taskCategory',
    type: 'select',
    options: taskCategories(availableServices),
    multiple: true,
  };
};

export const filters = ({
  bizClients,
  sites,
  businessClient,
  cleaningStatusFilters,
  // taskTypeFilters,
  services,
  companyId,
  userAssignedDepartments,
}) => {
  const filterTypes = {
    RegularFilters: [
      {
        label: 'Archived',
        field: 'archived',
        type: 'toggle',
      },
      {
        label: 'businessClient',
        field: 'businessClient',
        type: 'select',
        options: bizClients,
      },
      {
        label: 'site',
        field: 'site',
        type: 'select',
        options: filterOptions({
          options: sites,
          filterKey: 'businessClientId',
          filterValue: businessClient,
        }),
      },
      taskCategoryFilter(getServiceTaskCategories({ services })),
    ],
    AdvancedFilters: [
      {
        label: 'status',
        field: 'status',
        type: 'select',
        options: cleaningStatusFilters,
        multiple: true,
      },
      TASK_FIELDS.linkAssetId({
        securityCompanyId: companyId,
        archived: false,
        // multiple: true,
        useAsyncInFilters: true, // if you are using async-select in filters make sure this is set to true
      }),
      ...departmentFilter(userAssignedDepartments),
    ],
  };
  return filterTypes;
};
